import { Box, Checkbox, Divider, DropdownMenu, Input } from "@nulogy/components";
import React from "react";
import styled from "styled-components";

const StyledInput = styled(Input)(({ theme }) => ({
  input: {
    backgroundColor: theme.colors.white,
    color: theme.colors.black,
    opacity: 1,
    overflow: "hidden",
    textAlign: "left",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
}));

function getMessage({ options, value }) {
  if (value.length === 0) {
    return "None selected";
  }
  if (value.length === options.length) {
    const total = options.length;

    return `All (${total}/${total})`;
  }
  if (value.length === 1) {
    const selectedName = options.find((option) => option.value === value[0])?.label;
    const total = options.length;

    return `${selectedName} (1/${total})`;
  }

  const selectedCount = value.length;
  const total = options.length;

  return `Multiple (${selectedCount}/${total})`;
}

export default function CheckboxSelect({
  errorMessage,
  options,
  value,
  onChange,
  width = "300px",
  allowSelectAll = true,
  "data-testid": dataTestId = null,
  className = null,
}) {
  const message = getMessage({ options, value });

  const handleChange = (option) => {
    if (!onChange) return;

    const itemsToSet = () => {
      if (option === "all") {
        return value.length === options.length ? [] : options.map((anOption) => anOption.value);
      }
      if (value.includes(option)) {
        return value.filter((id) => id !== option);
      }

      return [...value, option];
    };

    const items = itemsToSet();
    onChange(items);
  };

  const checkboxes = options.map(({ label, value: optionValue }) => (
    <Checkbox
      checked={value.includes(optionValue)}
      data-testid={`checkbox-option-${optionValue}`}
      key={optionValue}
      labelText={label}
      onChange={() => handleChange(optionValue)}
      onClick={(event) => event.stopPropagation()}
      pl="x1"
      value={optionValue}
    />
  ));

  if (allowSelectAll) {
    checkboxes.unshift(<Divider key="divider" mx="x1" my="half" />);

    checkboxes.unshift(
      <Checkbox
        checked={value.length === options.length}
        data-testid="checkbox-option-all"
        key="all"
        labelText="Select all"
        onChange={() => handleChange("all")}
        onClick={(event) => event.stopPropagation()}
        pl="x1"
        value="all"
      />,
    );
  }

  return (
    <Box className={className} data-testId={dataTestId} position="relative" width={width}>
      <DropdownMenu
        data-testid="checkbox-select-dropdown"
        maxHeight="260px"
        overflowY="auto"
        showArrow={false}
        trigger={() => (
          <StyledInput
            data-testid="dropdown-trigger"
            disabled
            errorMessage={errorMessage}
            iconRight="downArrow"
            iconRightSize="20px"
            inputWidth={width}
            value={message}
            width={width}
          />
        )}
        width={width}
      >
        {checkboxes}
      </DropdownMenu>
    </Box>
  );
}
